

// @ts-nocheck

import Vue from 'vue'

export default Vue.extend({
    props: {
        fieldAddress: Array
    },
    computed: {
        isLTDCustomer() {
            return (this.$store.state.dash.viewData.business.isAppSumo || this.$store.state.dash.viewData.business.isPitchground || this.$store.state.dash.viewData.business.isDealify || this.$store.state.dash.viewData.business.isFBLLTD)
        },
        //PRICING 2026: per-plan video cap from the resolved plan (5 free / 50 solo /
        //200 auto / 1000 pro, special overrides included)
        videoLimitDisplay() {
            const limit = this.$store.getters['dash/planResolved'].limits.videoLimit
            return limit === Infinity ? 'unlimited videos' : `up to ${limit} videos`
        },

        field: {
            get: function (): string | false {
                return this.$store.getters["survey/stepField"](this.fieldAddress);
            },
            set: function (v: string): void {
                this.$store.commit("survey/CHANGE_FIELD", {
                    fieldAddress: this.fieldAddress,
                    val: v,
                });
            },
        }
    }
})

